import { render, staticRenderFns } from "./DeletionOfCPA.vue?vue&type=template&id=cc4d4732"
import script from "./DeletionOfCPA.vue?vue&type=script&lang=js"
export * from "./DeletionOfCPA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports